import React from 'react'
import logo1 from './pic/nas.png'

const Footer = () => {
  return (
    <>
      <footer>
        <div className='conatiner text-center top'>
          <div className='img'>
            <img src={logo1} alt='' width={70} />
          </div>
          <p>© {new Date().getFullYear()}. nascript</p>
        </div>
      </footer>
    </>
  )
}

export default Footer
